(function () {
  var form = document.getElementById('product-form');
  var data = document.getElementById('variants-json');
  if (!form || !data) return;
  var variants = JSON.parse(data.textContent);
  var selects = form.querySelectorAll('[data-option-index]');
  var idInput = form.querySelector('input[name=id]');
  var btn = form.querySelector('[data-add]');
  var price = document.querySelector('[data-price]');
  var compare = document.querySelector('[data-compare]');
  function update() {
    var chosen = Array.prototype.map.call(selects, function (s) { return s.value; }).join('|');
    var v = variants.find(function (x) { return x.options.join('|') === chosen; });
    if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
    idInput.value = v.id;
    if (price) price.textContent = v.price;
    if (compare) compare.textContent = v.compare || '';
    btn.disabled = !v.available;
    btn.textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-soldout');
    if (window.history && history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
  }
  selects.forEach(function (s) { s.addEventListener('change', update); });
})();
